module.exports = __webpack_public_path__ + "static/media/LimitReached.c97094f6.svg";